import { Button } from "antd";
import React from "react";

const NewFormActions = ({ isEdit = false, onHandleClose, isLoading }) => {
  return (
    <div>
      {" "}
      <div className="actions-container">
        <button type="button" className="login-btn cancel">
          <span className="login-btn-text" onClick={onHandleClose}>
            CANCEL
          </span>
        </button>

        <Button loading={isLoading} className="login-btn" htmlType="submit">
          <span className="login-btn-text">{isEdit ? "UPDATE" : "ADD"}</span>
        </Button>
      </div>
    </div>
  );
};

export default NewFormActions;
